import React from 'react'

import { Skeleton } from '../../../../../ui/skeleton'

export const HeaderInfoEmpty = () => {
  return (
    <div className="w-full flex-col sm:flex-row flex items-center gap-4">
      <Skeleton className="h-[64px] w-[64px] rounded-full mr-auto sm:mr-0" />
      <div className="sm:flex-1 w-full sm:w-auto space-y-2">
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-5 w-[46%] sm:w-[24%] rounded-full" />
          <Skeleton className="h-5 w-[23%] sm:w-[12%] rounded-full" />
          <Skeleton className="h-5 w-[23%] sm:w-[12%] rounded-full" />
        </div>
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-4 w-full sm:w-[20%] rounded-full" />
          <Skeleton className="h-4 w-full sm:w-[20%] rounded-full" />
          <Skeleton className="h-4 w-full sm:w-[20%] rounded-full" />
        </div>
      </div>
      <Skeleton className="h-9 w-full sm:w-28 rounded-full" />
    </div>
  )
}
